import React from "react";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { Card, CardContent, Stack, Typography, useTheme } from "@mui/material/index";
import {useRecoilValue} from "recoil";
import {useFormContext} from "react-hook-form";
import {FormAutocomplete, FormTextField} from "../../common/form-fields-wrappers";
import {IExpiredRecoveryEntrustmentForm} from "../../models/models";
import {recoveryCompaniesState} from "../../state";

interface RecoveryEntrustmentDetailProps {
    forView?: boolean
}

const RecoveryEntrustmentDetail = ({forView = false}: RecoveryEntrustmentDetailProps ) => {
    const {t} = useTranslation(['expiredManagement']);
    const theme = useTheme();
    const recoveryEntrustmentDetailForm = useFormContext<IExpiredRecoveryEntrustmentForm>();
    const recoveryCompanies = useRecoilValue(recoveryCompaniesState);

    const handleSelectRecoveryEntrustmentCompany = (e: React.BaseSyntheticEvent) => {
        const company = recoveryEntrustmentDetailForm.getValues('recoveryCompany');
        recoveryEntrustmentDetailForm.setValue('to', company?.email || '');
        recoveryEntrustmentDetailForm.trigger('to');
    }

    return(
        <Grid container spacing={theme.spacing(2)}>
            <Grid item xs={12} md={6}>
                <FormAutocomplete
                    name={'recoveryCompany'}
                    label={t("recoveryEntrustment.form.label.recuperator")}
                    control={recoveryEntrustmentDetailForm.control}
                    fullWidth
                    options={recoveryCompanies}
                    isOptionEqualToValue={(option: any, value: any) => option?.name === value?.name}
                    getOptionLabel={(opt: any) => recoveryCompanies.find((x: any) => x.name === opt.name)?.name || ""}
                    onChange={handleSelectRecoveryEntrustmentCompany}
                    required
                    disabled={forView}
                />
            </Grid>
            {!forView &&
                <Grid item xs={12} md={6}>
                    <FormTextField
                        name={'rentalType'}
                        label={t("recoveryEntrustment.form.label.rentalType")}
                        control={recoveryEntrustmentDetailForm.control}
                        disabled
                        fullWidth
                    />
                </Grid>
            }
            {/*<Grid item xs={12}>*/}
            {/*    <FormTextField<IExpiredRecoveryEntrustmentForm>*/}
            {/*        name="phoneNumber"*/}
            {/*        label={t("Numero Telefono")}                */}
            {/*    />*/}
            {/*</Grid>*/}
            <Grid item xs={12}>
                <FormTextField<IExpiredRecoveryEntrustmentForm>
                    name="to"
                    label={t("recoveryEntrustment.form.label.to")}
                    control={recoveryEntrustmentDetailForm.control}
                    required
                    disabled
                />
            </Grid>
            <Grid item xs={12}>
                <FormTextField<IExpiredRecoveryEntrustmentForm>
                    name="object"
                    label={t("recoveryEntrustment.form.label.object")}
                    control={recoveryEntrustmentDetailForm.control}
                    disabled
                />
            </Grid>
            {/*<Grid item xs={12}>*/}
            {/*    <FormTextField<IExpiredRecoveryEntrustmentForm>*/}
            {/*        name="from"*/}
            {/*        label={t("Da")}        */}
            {/*    />*/}
            {/*</Grid>*/}

            <Grid item xs={12}>
                <Stack direction={"column"} gap={theme.spacing(2)} pt={theme.spacing(2)}>
                    <Typography >{t('recoveryEntrustment.form.label.message')}</Typography>
                    <Card
                        variant="outlined"
                        sx={{
                            borderColor: 'primary.main'
                        }}
                    >
                        <CardContent>
                            <FormTextField<IExpiredRecoveryEntrustmentForm>
                                name="message"
                                control={recoveryEntrustmentDetailForm.control}
                                autoFocus
                                fullWidth
                                multiline
                                rows={15}
                                InputProps={{
                                    disableUnderline: true
                                }}
                                //error={!!textWatch ? (textWatch.length > MAIL_MAX_CHAR) : false}
                                //helperText={((textWatch?.length || '0') + ' / ' + MAIL_MAX_CHAR)}
                                FormHelperTextProps={{
                                    component: "div"
                                } as any}
                                required
                                disabled
                            />
                        </CardContent>
                    </Card>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default RecoveryEntrustmentDetail;